/* ==========================================================================
   RAIKI - Giro por toque en pantallas táctiles

   Este archivo SOLO se carga si el cliente activa "Girar al tocar" desde el
   panel. En escritorio el giro lo resuelve el CSS con :hover y este script
   ni se descarga.

   Comportamiento: el primer toque gira la tarjeta, el segundo entra al
   producto. Es el patrón esperado en catálogos táctiles: si el primer toque
   navegara, el reverso nunca se vería en un teléfono.
   ========================================================================== */

(function () {
  'use strict';

  // Si el dispositivo tiene cursor real, el CSS ya se encarga. No hacemos nada.
  if (window.matchMedia('(hover: hover)').matches) return;

  document.addEventListener(
    'click',
    function (evento) {
      var cara = evento.target.closest('.raiki-card__face');
      if (!cara) return;

      var tarjeta = cara.closest('.raiki-card');
      if (!tarjeta || tarjeta.dataset.girarAlTocar !== 'true') return;

      // Si la tarjeta ya está girada, dejamos pasar el clic al enlace.
      if (tarjeta.classList.contains('is-flipped')) return;

      // Primer toque: giramos y frenamos la navegación.
      evento.preventDefault();

      // Solo una tarjeta girada a la vez, para no dejar el catálogo revuelto.
      document.querySelectorAll('.raiki-card.is-flipped').forEach(function (otra) {
        if (otra !== tarjeta) otra.classList.remove('is-flipped');
      });

      tarjeta.classList.add('is-flipped');
    },
    false
  );

  // Tocar fuera de las tarjetas devuelve todo a su posición.
  document.addEventListener('click', function (evento) {
    if (evento.target.closest('.raiki-card')) return;
    document.querySelectorAll('.raiki-card.is-flipped').forEach(function (t) {
      t.classList.remove('is-flipped');
    });
  });
})();
